import { render, staticRenderFns } from "./WorkflowVizToolbarMenus.vue?vue&type=template&id=0b9bc886&scoped=true"
import script from "./WorkflowVizToolbarMenus.vue?vue&type=script&lang=js"
export * from "./WorkflowVizToolbarMenus.vue?vue&type=script&lang=js"
import style0 from "./WorkflowVizToolbarMenus.vue?vue&type=style&index=0&id=0b9bc886&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bc886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9bc886')) {
      api.createRecord('0b9bc886', component.options)
    } else {
      api.reload('0b9bc886', component.options)
    }
    module.hot.accept("./WorkflowVizToolbarMenus.vue?vue&type=template&id=0b9bc886&scoped=true", function () {
      api.rerender('0b9bc886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealMultiQueryWorkflow/WorkflowVizToolbarMenus.vue"
export default component.exports